import Table from "@mui/material/Table";
import { ComponentProps } from "../types";

function Component({ component }: ComponentProps) {
	return <Table key={component.id} />;
}

export default Component;
